import React, {Component} from 'react';
import T from 'i18n-react';
import {Link} from 'react-router';
import {grey300, grey50, orange500, teal300} from 'material-ui/styles/colors';
import NotificationSystem from 'react-notification-system';

// Material ui
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

// WS
import UserService from '../../../services/UserService';

// Enum
import PAGES from '../../../enums/PageEnum';
import COLORS from '../../../enums/ColorEnum';

//Style
import '../login/Login.css';


const styles = {
    errorStyle: {
        color: orange500,
    },
    underlineStyle: {
        borderColor: orange500,
    },
    hintStyle: {
        color: grey300,
    },
    inputStyle: {
        color: grey50,
    },
    floatingLabelStyle: {
        color: grey300,
    },
    floatingLabelFocusStyle: {
        color: grey300,
    },
    labelStyle: {
        fontWeight: '100',
        letterSpacing: '2px',
    }
};

/**
 * Style du toastr
 */
const notificationStyle = {
    NotificationItem: {
        success: {
            color: COLORS.WHITE,
            backgroundColor: COLORS.GREEN,
            borderTop: 'none'
        }
    },
    MessageWrapper: {
        DefaultStyle: {
            margin: 0,
            marginTop: '30px',
            padding: 0,
            height: '50px',
            fontSize: 'initial',
            textAlign: 'center'
        }
    },
    Dismiss: {
        DefaultStyle: {
            backgroundColor: 'transparent'
        }
    }
};
class ResetPassword extends Component {

    /*************************************************
     * **************** LifeCycle ********************
     *************************************************/
    constructor(props) {
        super(props);
        this.state = {
            login: "",
            error: false
        };
        this.validAction = this.validAction.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }

    render() {
        return(
            <form onSubmit={this.validAction}>
                <h1>{T.translate("login.resetPassword.label")} {this.state.error}</h1>
                { this.state.error &&
                    <span className="error loginError">{T.translate("login.resetPassword.error")}</span>
                }
                <TextField id="loginFieldControlledReset"
                            name="login"
                            hintText={T.translate("login.username")}
                            floatingLabelText={T.translate("login.username")}
                            fullWidth={true}
                            hintStyle={styles.hintStyle}
                            floatingLabelStyle={styles.floatingLabelStyle}
                            floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                            inputStyle={styles.inputStyle}
                            value={this.state.login}
                            onChange={this.handleInputChange.bind(this)}/>
                <Link to={PAGES.LOGIN_PAGE}> {T.translate('addUser.back')} </Link>
                <RaisedButton label={T.translate("login.confirm")} secondary backgroundColor={teal300} labelColor={grey50} className="sign-in-button" type="submit" />
                <NotificationSystem ref="notificationSystem" style={notificationStyle}/>
            </form>
        );
    }

    /**********************************************************
     * **************** Actions composants ********************
     **********************************************************/

     validAction(e) {
        e.preventDefault();
         UserService.sendKeypass(this.state.login).then((data) => {
            this._addNotification(T.translate('login.resetPassword.mailSend'), 'success');
         }).catch((error) => {
             this._addNotification(T.translate('errors.internalServerError'), 'error');
         })
     }

     handleInputChange(event) {
        const target = event.target;
        const value = target.value;

        this.setState({
            login: value,
            error: false
        });
     }

     /*************************************************
     ****************Notifications ******************
     *************************************************/

    _notificationSystem = null;

    _addNotification = (message, level) => {
        this._notificationSystem.addNotification({
            message,
            autoDismiss: 3,
            level,
            position: 'tr'
        });
    }

}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/ui/connexion/resetPassword/ResetPassword.js